import React from 'react';

const Processing = () => {
  return (
    <div className="centered" style={{ display: 'flex' }}>
      <div className="card">
        <div className="loading-spinner"></div>
        <p style={{ marginTop: '20px', fontSize: '15px', color: '#333' }}>
          Updating your credentials...
        </p>
      </div>
    </div>
  );
};

export default Processing;